import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { StatusColors } from '@lendica/utils';

export type TagColor =
    | 'primary'
    | 'error'
    | 'info'
    | 'text'
    | 'dark'
    | 'success'
    | 'warning'
    | 'default';

export interface TagProps {
    color?: TagColor | string;
    label: string;
}

const colorMapping: { [key: string]: string } = {
    primary: StatusColors.HavelockBlue,
    error: StatusColors.BurntSienna,
    info: StatusColors.ShuttleGray,
    text: StatusColors.ShuttleGray,
    dark: StatusColors.ShuttleGray,
    success: StatusColors.MeadowGreen,
    warning: StatusColors.MeteorOrange,
    default: StatusColors.MexicanRed,
};

export const Tag: FC<TagProps> = ({ color = 'info', label }) => {
    return (
        <Box
            sx={{
                height: 20,
                bgcolor: `${colorMapping[color] || color}`,
                px: 0.5,
                borderRadius: 1,
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                whiteSpace: 'nowrap',
            }}
        >
            <Typography
                variant="caption"
                color={theme => theme.palette.getContrastText(colorMapping[color] || color)}
            >
                {label}
            </Typography>
        </Box>
    );
};
